var Reflux = require('reflux');

module.exports = Reflux.createActions([
  "fetchChannels",
  "showChannel"
]);



// WEBPACK FOOTER //
// ./src/advocate/challenges/actions/channels_actions.js